export default __webpack_public_path__ + "static/media/Logos_Myyja.c9239a49.svg";